// MARK: SMS + Email connector
import { z } from 'zod';
export var VerificationCodeType;
(function (VerificationCodeType) {
    VerificationCodeType["SignIn"] = "SignIn";
    VerificationCodeType["Register"] = "Register";
    VerificationCodeType["ForgotPassword"] = "ForgotPassword";
    VerificationCodeType["Generic"] = "Generic";
    /** @deprecated Use `Generic` type template for sending test sms/email use case */
    VerificationCodeType["Test"] = "Test";
})(VerificationCodeType || (VerificationCodeType = {}));
export const verificationCodeTypeGuard = z.nativeEnum(VerificationCodeType);
export const sendMessagePayloadGuard = z.object({
    code: z.string(),
});
export const urlRegEx = /(https?:\/\/)?(?:www\.)?[\w#%+.:=@~-]{1,256}\.[\d()A-Za-z]{1,6}\b[\w#%&()+./:=?@~-]*/;
export const emailServiceBrandingGuard = z
    .object({
    senderName: z
        .string()
        .refine((address) => !urlRegEx.test(address), 'DO NOT include URL in the sender name!'),
    companyInformation: z
        .string()
        .refine((address) => !urlRegEx.test(address), 'DO NOT include URL in the company information!'),
    appLogo: z.string().url(),
})
    .partial();
export const sendMessageDataGuard = z.object({
    to: z.string(),
    type: verificationCodeTypeGuard,
    payload: sendMessagePayloadGuard,
});
